import { UseContextsCompetence } from "#competence/contexts/ContextsCompetence"
import { CalendarToday, CheckCircle, Person, Public } from "@mui/icons-material"
import { Box, Card, CardContent, CardHeader, Stack, Typography } from "@mui/material"

export default function CompetenceInfoGeneral() {
	const { competence } = UseContextsCompetence()
	return (
		<Card elevation={2}>
			<CardHeader
				title={
					<Typography variant="h6" component="h2">
						Información General
					</Typography>
				}
			/>
			<CardContent>
				<Stack spacing={2}>
					<Items
						{...{
							label: "Descripción de uso",
							value: competence.description,
							Icon: CheckCircle,
						}}
					/>
					<Stack direction={"row"} spacing={2}>
						{/* <Stack flex={1} spacing={1}>
						<Items
							{...{
								label: "Usado en",
								value: `${competence.usageCount} lugares`,
								Icon: Public,
							}}
						/>
					</Stack> */}
						<Stack flex={1} spacing={1}>
							<Items
								{...{
									label: "Creado por",
									value: competence.created_by_name,
									Icon: Person,
								}}
							/>
							<Items
								{...{
									label: "Fecha de creación",
									value: competence.created_at,
									Icon: CalendarToday,
								}}
							/>
						</Stack>
						{competence.updated_by && (
							<Stack flex={1} spacing={1}>
								<Items
									{...{
										label: "Editado por",
										value: competence.updated_by_name,
										Icon: Person,
									}}
								/>
								<Items
									{...{
										label: "Fecha de edición",
										value: competence.updated_at,
										Icon: CalendarToday,
									}}
								/>
							</Stack>
						)}
					</Stack>
				</Stack>
			</CardContent>
		</Card>
	)
}

const Items = ({ label, value, Icon }) => {
	return (
		<Box>
			<Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
				<Icon fontSize="small" color="action" />
				<Typography variant="body2" color="text.secondary">
					{label}
				</Typography>
			</Box>
			<Typography variant="body1" fontWeight="medium">
				{value}
			</Typography>
		</Box>
	)
}
